<template>
    <v-container class="container-view">
        <loader v-if="showLoader"></loader>
        <v-row class="d-flex justify-center white--text">
            <h1>Votos vs Votantes</h1>
        </v-row>
        <v-row class="d-flex justify-center">
            <table width="100%" class="table-filters">
                <tbody>
                    <tr>
                        <td width="20%">
                            Elecciones
                        </td>
                        <td width="80%">
                            <v-select
                                :items="elecciones"
                                :item-text="textItemElection"
                                item-value="id"
                                label="Selecciona elección"
                                v-model="electionIdSelected"
                                @change="onChangeElection"
                                :loading="loading"
                            >
                            </v-select>
                        </td>
                    </tr>
                </tbody>
            </table>
        </v-row>

        <v-row v-if="!showLoader">
            <v-col v-for="centro in centros" cols="12" md="12" :key="centro.id">
                <PreviewResults v-bind:data="centro"></PreviewResults>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import VueApexCharts from 'vue-apexcharts';
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue';
import { mapGetters } from 'vuex';
// import ResultCentros from '../components/ResultCentros';
import Loader from '../components/common/Loader';
import PreviewResults from '../components/PreviewResults';

export default {
    name: 'preview',
    components: {
        PreviewResults,
        Loader,
        // ResultCentros,
        apexchart: VueApexCharts,
        ScaleLoader,
    },
    computed: {
        ...mapGetters({
            elecciones: 'elecciones/elecciones',
        }),
    },
    data: () => {
        return {
            cgu: [],
            centros: [],
            colors: [],
            hexa_colors: [],
            loading: false,
            showLoader: false,
            dialog: false,
            series: [],
            uresList: [],
            centers: [],
            tables: [],
            electionIdSelected: '',
            centerSelected: '',
            uresSelected: '',
            tableSelected: [],
            tableList: [],
            tableListTotal: 0,
            candidates: {
                loading: false,
                color: '',
                id_planilla: '',
                hexa_color: '#002145',
                data: [],
            },
        };
    },
    methods: {
        onChangeElection: function() {
            this.uresList = [];
            this.uresSelected = '';
            if (this.electionIdSelected) {
                this.generateChart();
            }
        },

        generateChart: function() {
            this.showLoader = true;
            const filters = {
                election_id: this.electionIdSelected,
                center_id: this.centerSelected,
                ures: this.uresSelected,
                table_id: this.tableSelected == '' ? [] : this.tableSelected,
            };
            this.loading = true;
            this.$store
                .dispatch('prep/getPreviewDivision', filters)
                .then(res => {
                    console.log(res);

                    this.cgu = res.cgu;
                    this.centros = res.centros;
                    this.colors = res.colors;
                    this.hexa_colors = res.hexa_colors;
                    this.ocgs = res.ocgs;
                })
                .finally(() => {
                    this.loading = false;
                    this.showLoader = false;
                });
        },

        textItemElection: item =>
            `${item.id} - ${item.description} | ${item.type.toUpperCase()}`,

        textColorChip: color => {
            let colorText = 'FFFFFF';
            switch (color) {
                case 'FFFF00':
                case 'DADADA':
                    colorText = '002145';
                    break;
            }
            return '#' + colorText;
        },
        textColorCard: color => {
            switch (color) {
                case 'FFFF00':
                    color = 'F8F32B';
                    break;
            }
            return '#' + color;
        },
    },
    created() {
        this.$store.dispatch('elecciones/getElecciones');
    },
};
</script>
<style lang="scss"></style>
